enum LoginWorkflowStepEnum {
    ChangeTempPassword,
    LoadCache,
    LoadTitlesAndSpecialtiesCache,
    AcceptAgreement,
    UserTypeAssignment,
    RequiredRecoveryEmailFlow,
    RequiredMandatoryMultiFactorAuthenticationSetUpFlow
}

export { LoginWorkflowStepEnum };
